var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-checkable-tag',{staticClass:"tag-default",on:{"change":function($event){return _vm.$emit('click')}},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }